import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://rkczmrqcuntoqqcwjead.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJrY3ptcnFjdW50b3FxY3dqZWFkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA5OTE3MzQsImV4cCI6MjA4NjU2NzczNH0.Cz7ylDOzB5upw22Mway-URUZjEM78BMWAgDia_fBrYU'

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Import the supabase client like this:
// For React:
// import { supabase } from "@/integrations/supabase/client";
// For React Native:
// import { supabase } from "@/src/integrations/supabase/client";
